import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJumpToElement = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "jump_to_element",
		d: "M9.2115 10.7885V7.2885H10.7115V9.2885H12.7115V10.7885H9.2115ZM16 10.7885V9.2885H18V7.2885H19.5V10.7885H16ZM9.2115 4V0.5H12.7115V2H10.7115V4H9.2115ZM18 4V2H16V0.5H19.5V4H18ZM1.55375 19.5L0.5 18.4462L6.65775 12.2885H1.5V10.7885H9.2115V18.5H7.7115V13.3422L1.55375 19.5Z",
		fill: "currentColor"
	})
});
export default SvgJumpToElement;
